import { useEffect } from 'react'
import { useState } from 'react'

const getLocalStream = async (): Promise<MediaStream | null> => {
  const { mediaDevices } = navigator
  let stream: MediaStream | null = null
  try {
    stream = await mediaDevices.getUserMedia({
      video: {
        width: { ideal: 560 },
        height: { ideal: 360 }
      }
    })
  } catch (err) {
    console.error(err)
  }

  return stream
}

export const useLocalStream = (videoRef: React.RefObject<HTMLVideoElement>) => {
  const [localStream, setLocalStream] = useState<MediaStream | null>(null)
  const [preparingLocalStream, setPreparingLocalStream] = useState<boolean>(
    true
  )
  useEffect(() => {
    if (videoRef.current?.srcObject) return
    getLocalStream().then((localStream) => {
      if (!localStream) {
        alert('カメラの映像を取得できませんでした。')
        setPreparingLocalStream(false)
        return
      }
      setLocalStream(localStream)
      setPreparingLocalStream(false)
    })
  }, [videoRef])

  useEffect(() => {
    if (!videoRef.current || !localStream || videoRef.current.srcObject) return
    videoRef.current.srcObject = localStream
  }, [localStream, videoRef])

  return { localStream, preparingLocalStream }
}
